import styled from "styled-components";
import {OnActiChoice, OnEmplChoice} from "../NouvelleFormation";
import {FaPlus} from "react-icons/fa";

interface OneCardEmplToChoiceCtrlProps {
  className?:string;
  Employee:OnEmplChoice;
  AddEmpl:(e:OnEmplChoice)=>void;
}

const OneCardEmplToChoiceCtrl = (props: OneCardEmplToChoiceCtrlProps) => {
  return (
    <div className={"empl_to_add "+props.className } onClick={()=>props.AddEmpl(props.Employee)}>
      <div className="libActi">{props.Employee.libelle}</div>
      <div className="wrap_add">
        <FaPlus />
      </div>
    </div>
  )
}

export const OneCardEmplToChoice = styled(OneCardEmplToChoiceCtrl)`
  width: 100%;
  padding: 0.5rem;
  display: flex;
  border-radius: 4px;
  .libActi{
    flex-grow: 1;
    padding: 0 0.25rem;
  }
  .wrap_add{
    width: 0;
    position: relative;
    overflow: hidden;
    svg{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }
  &:hover{
    cursor: pointer;
    background: ${props => props.theme.thirdPastel};
    .wrap_add{
      transition: width 0.3s;
      width: 32px;
    }
  }
`
